import React from 'react';

interface State { error: Error | null; }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#0f1117] flex items-center justify-center">
          <div className="text-center space-y-4 p-8 max-w-md">
            <div className="text-red-400 text-2xl font-bold">Something went wrong</div>
            <div className="text-gray-400 text-sm font-mono bg-gray-900 rounded-lg px-4 py-3">
              {this.state.error.message}
            </div>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg text-sm transition-colors"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
